export const captchaActive = process.env.REACT_APP_RECAPTCHA_ACTIVE === undefined ? true 
    : process.env.REACT_APP_RECAPTCHA_ACTIVE.toLowerCase() === 'true'
export const captchakey = process.env.REACT_APP_RECAPTCHA_KEY